import * as React from 'react';
import { Text, View } from 'react-native';

import Colors from '../constants/Colors'
import FontStyles from '../constants/FontStyle';

export default function TabBarIcon({ focused, color, title }) {
  return title
    ? < Text
      style={{
        ...FontStyles.size12,
        ...FontStyles.lh14,
        ...FontStyles.normal,
        color: focused ? Colors.tabIconSelected : Colors.tabIconDefault,
        marginVertical: 0,
        height: 14,
        maxHeight: 14,
      }}
    >{title}</Text >
    : null
}
